import React, { useEffect, useRef, useState } from 'react';
import './Loader.scss';

interface LoaderProps {
  isVisible?: boolean;
  progress?: number | null;
}

export const Loader: React.FC<LoaderProps> = ({ isVisible = true, progress = null }) => {
  const [shouldRender, setShouldRender] = useState(isVisible);
  const [displayVisible, setDisplayVisible] = useState(isVisible);
  const visibleSinceRef = useRef<number | null>(null);
  const hideVisibleTimerRef = useRef<number | null>(null);
  const unmountTimerRef = useRef<number | null>(null);

  useEffect(() => {
    if (isVisible) {
      if (hideVisibleTimerRef.current) {
        clearTimeout(hideVisibleTimerRef.current);
        hideVisibleTimerRef.current = null;
      }
      if (unmountTimerRef.current) {
        clearTimeout(unmountTimerRef.current);
        unmountTimerRef.current = null;
      }
      visibleSinceRef.current = Date.now();
      setShouldRender(true);
      setDisplayVisible(true);
      return;
    }

    const shownAt = visibleSinceRef.current;
    const elapsed = shownAt ? Date.now() - shownAt : 0;
    const remainingToOneSecond = Math.max(1000 - elapsed, 0);

    hideVisibleTimerRef.current = window.setTimeout(() => {
      setDisplayVisible(false);
    }, remainingToOneSecond);

    unmountTimerRef.current = window.setTimeout(() => {
      setShouldRender(false);
    }, remainingToOneSecond + 500);

    return () => {
      if (hideVisibleTimerRef.current) {
        clearTimeout(hideVisibleTimerRef.current);
        hideVisibleTimerRef.current = null;
      }
      if (unmountTimerRef.current) {
        clearTimeout(unmountTimerRef.current);
        unmountTimerRef.current = null;
      }
    };
  }, [isVisible]);

  if (!shouldRender) return null;

  return (
    <div className={`loader-overlay ${displayVisible ? 'visible' : ''}`}>
      <div className="loader-spinner"></div>
      {typeof progress === 'number' && progress > 0 && (
        <div className="loader-progress">{progress}%</div>
      )}
    </div>
  );
};
